<template>
  <div class="align-center">
    <p>Votre code:</p>
    <strong class="binding-code">{{ bindingCode }}</strong>
  </div>
</template>

<script>

import {mapState, mapActions} from 'vuex'

export default {
  name: 'BindingCode',
  computed: {
    ...mapState('sessionStore', ['bindingCode'])
  }
}
</script>
<style>
  .binding-code {
    font-size: 40px
  }
</style>



// WEBPACK FOOTER //
// BindingCode.vue?25f6bbbc